<footer class="py-4 text-center text-xs text-gray-400">
  @if (version(); as version) {
    <span>v{{ version }}</span>
  }
</footer>
